import React, {useState} from "react";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import SearchTable from "../../../primer/Search-Table";


const SearchExams = () => {
    const searchFilters = {
        filters: [
            {
                name: "filter",
                label: "Φίλτρο ονόματος/περιγραφής",
                type: "input",
            },
            {
                name: "codeEdapi",
                label: "Κωδικός ΔΑΠΥ",
                type: "input",
            },
        ],
        actions: [],
    }

    const searchColumns = [
        {
            name: "Κωδικός ΔΑΠΥ",
            field: "codeEdapi",
            editable: false,
            width: "15%",
            inputType: {
                type: "text",
            }
        },
        {
            name: "Περιγραφή",
            field: "description",
            editable: false,
            width: "65%",
            inputType: {
                type: "text",
            }
        },
        {
            name: "Τιμή",
            field: "price",
            editable: false,
            width: "20%",
            inputType: {
                type: "text",
            }
        },
    ]

    const [tableColumns, setTableColumns] = useState(searchColumns.slice());

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <div>
            <SearchTable
                tableName={"Prescription Search Exams"}
                key={"Prescription Search Exams"}
                hideYearFilter={true}
                allowPagination={true}
                allowToggleColumns={true}
                showDummyData={false}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                allowSelectionCheckbox={false}
                data={[]}
                filtersConfig={searchFilters}
                allowSorting={false}
            />
        </div>
    )
}

export default SearchExams;
